import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import smoothscroll from 'smoothscroll-polyfill';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(() => {});
}

// Load polyfill asynchronously to not block bootstrap
setTimeout(() => smoothscroll.polyfill(), 0);

// Optimize bootstrap timing for better LCP
if (document.readyState === 'complete') {
  // Use setTimeout to allow critical CSS to be processed first
  setTimeout(bootstrap, 0);
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
